const distributions = {
  payeeType: {
    title: "Payee Type Management",
    tableTitle: "Payee Type",
    tableDescription:
      "Payee type management is used to identify special payees, including Taxing authorities, and other types of withholding payees who are not the creditor themselves such as garnishnors.",
    createNewPayeeType: "New Payee Type",
    createPayeeTitle: "Payee Type Details",
    createPayeeDescription:
      "Payee type management is used to identify special payees, including Taxing authorities, and other types of withholding payees who are not the creditor themselves such as garnishnors.",
    payeeLevelOptions: {
      label1: "Select Payee Level",
      label2: "Creditor Level",
      label3: "Case Level",
    },
    formLabels: {
      name: "Name",
      nameFrench: "Name (French)",
      payeeLevel: "Payee Level",
      description: "Description",
      paymentDetails: "Payment Details",
      contactDetails: "Contact Details",
      institutionNumber: "Institution Number",
      transitNumber: "Transit Number",
      accountNumber: "Account Number",
      IBANNumber: "IBAN Number",
      SWIFTCode: "SWIFT Code",
      routingCode: "Routing Code",
      ACHCode: "ACH Code",
      prefix: "Prefix",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phoneNumber: "Phone Number",
      fax: "Fax",
      address1: "Address 1",
      address2: "Address 2",
      businessName: "Business Name",
      country: "Country",
      city: "City",
      postalCode: "Postal Code",
      provinceState: "Province State",
    },
    PayeeUpdatedMessage: "Payee Type updated successfully",
    PayeeCreatedMessage: "Payee Type created successfully",
    PayeeDeletedMessage: "Payee Type deleted successfully",
    validationMessages: {
      deleteWarningMessage:
        "Are you sure you want to delete this payee type <strong>{{deleteEntityName}}</strong>?",
      nameRequired: "Name is required",
      payeeRequired: "Payee Level is required",
      firstNameRequired: "First Name is required",
      lastNameRequired: "Last Name is required",
    },
    bannerDetails: {
      title: "Payee Type Name",
      label1: "Payee level",
      case: "Case",
      creditor: "Creditor",
      label2: "Last Updated",
    },

    columnDetails: {
      column1: "Payee Type Name",

      column2: "Payee Level",

      column3: "Description",
    },
  },
  manualDataSource: {
    uploadManualData: "Upload Manual Data",
    confirmationMessage:
      "Are you sure to delete manual data source <strong>{{deleteEntityName}}</strong>?",
    deletedSuccessMessage:
      "Successfully deleted manual data source {{deleteEntityName}}.",
    bannerDetails: {
      title: "Manual Data Source Name",
      label1: "Total Records",
      label2: "Updated On",
    },
    editManualSource: {
      columnDetails: {
        column1: "Distribution",

        column2: "Step",
      },
      title: "Manual Data Source Details",
      description:
        "Manual Data Sources are used to attach information that can not otherwise be determined or calculated, such as information determined by other parties, or where the calculation must be performed outside of CMS.",
      usage: "Usage",
      usageDescription:
        "This table shows the distribution steps where this Manual Data Source information is utilized as part of the distribution calculations.",
      name: "Name",
      download: "Download",
      nameFrench: "Name (French)",
      comment: "Comment",
      nameReq: "Name is required",
      sucessMessage: "Manual Data Source updated successfully.",
      errorMessage: "An error occurred while updating the manual data source.",
    },
    dataSourceUploader: {
      title: "Manual Data Source Upload",
      labels: {
        name: "Data Source Name",
        nameFrench: "Data Source Name (French)",
        comment: "Comment",
      },
      displayName: "Display Name: {{fileName}}",
      filesizeExceedsLimit:
        "This file exceeds the upload limit of {{filesize}} MB.",
      templateTitle: "Manual Data Source Upload Template",
      templateDescription: "Download template to create the import file",
      uploadText: "Click to upload or drag and drop",
      uploadDescription:
        "The accepted document format is XLSX only. The maximum size per file is 250 MB.",
    },
    tableTitle: "Manual Uploads",
    tableDescription:
      "Manual Data Sources are used to attach information that can not otherwise be determined or calculated, such as information determined by other parties, or where the calculation must be performed outside of CMS.",
    columnDetails: {
      column1: "Manual Data Source Name",
      column2: "Distribution Name",
      column3: "Total Records",
      column4: "Updated On",
    },
  },
  rateTire: {
    createTemplate: "Create from Template",
    noTemplete: "No templates available.",
    selectRateTire: "Select Rate Tier Template",
    validationMessage: {
      unExpectedError:
        "An unexpected error occurred while applying the template.",
      templatNotFound: "Selected template not found.",
      mainMessage: "Please complete all required fields to continue Template",
    },
    tableTitle: "Rate Tier Template",
    tableDescription: "Descriptive text that describes your page or content.",
    tableColumnDetails: {
      column1: "Name",
      column2: "Year",
      column3: "Jurisdiction",
      column4: "Created On",
      column5: "Created By",
      column6: "Active",
    },
  },
  account: {
    createAccount: "New Account",
    createSubAccount: "New Sub Account",
    subAccountPlaceholder: "Search Sub Accounts",
    title: "Account Management",
    accountTitle: "Account",
    subAccountTitle: "Sub Account",
    createAccountTitle: "Create Account",
    editAccountTitle: "Edit Account",
    createSubAccountTitle: "Create Sub Account",
    editSubAccountTitle: "Edit Sub Account",
    accountAlreadyExits: "A Account with the same name already exists.",
    subAccountValidationMessages: {
      nameRequired: "Sub Account Name is required",
    },
    accountLabels: {
      validationMessages: {
        accountNameReq: "Account Name is required",
        sequenceNumberReq: "Starting Sequence Number is required",
        sequenceNumberPattern: "Only number are allowed",
        instituteNumberReq: "Institute Number is required",
      },
      prefixDropDownLabels: {
        label1: "Cheque",

        label2: "Statement",

        label3: "Wire",

        label4: "Other",
      },
      accountName: "Account Name",
      accountNameFrench: "Account Name (French)",
      description: "Description",
      descriptionFrench: "Description (French)",
      prefix: "Prefix",
      unit: "Unit",
      startingSequenceNumber: "Starting Sequence Number",
      institutionNumber: "Institution Number",
      transitNumber: "Transit Number",
      accountNumber: "Account Number",
      clientNumber: "Client Number",
    },
    subAccountLabels: {
      subAccountName: "Sub Account Name",
      subAccountNameFrench: "Sub Account Name (French)",

      description: "Description",
      name: "Name",
      nameFrench: "Name (French)",
      descriptionFrench: "Description (French)",
      payemntOrderScheme: "Payment Order Scheme",
      includeTaxReport: "Include in Tax Report",
      includePaymentRegister: "Include in Payment Register",
    },
  },
  backButton: "Back to Home",
  distribution: {
    title: "Distributions",
    tableTitle: "Distribution",
    duplicate: "Duplicate",
    tableDescription:
      "A case may have multiple distributions. Each Distribution has it's own set of calculation steps that may be different from previous distributions. For example a final distribution with have a different distribution rate than an earlier interim distribution.",
    addNewDistribution: "New Distribution",
    tableColumnDetails: {
      column1: "Distribution Name",

      column2: "Status",

      column3: "Distribution Date",

      column4: "Effective Date",

      column5: "Creation On",
    },
    distributionEditPage: {
      title: "Distribution Summary",
      description:
        "The distribution date will be the date used for all subsequent payments under this distribution. It can be updated without disturbing previously issued payments. Once a distribution is committed, it can not be edited. To make further distributions after a committed distribution, a new distribution must be made (calculation steps will be rolled-forward into the new distribution).",
    },
    distributionViewPage: {
      title: "Distribution Summary",
      description:
        "The distribution date will be the date used for all subsequent payments under this distribution. It can be updated without disturbing previously issued payments. Once a distribution is committed, it can not be edited. To make further distributions after a committed distribution, a new distribution must be made (calculation steps will be rolled-forward into the new distribution).",
    },
    statusOptions: {
      unlocked: "Unlocked",
      locked: "Locked",
      committed: "Committed",
    },
    tabPannelDetails: {
      tab1: "Summary",
      tab2: "Steps",
    },
    caluclationSuccessMessage:
      "Calculation is completed for {{distributionName}}.",
    generateDraftSettlementButton: "Generate Draft Settlement",
    generateDraftEntitlementButton: "Generate Draft Entitlement",
    generateDraftSettlementConfirmationMessage:
      "All draft payments will be deleted once draft settlement is calculated. Are you sure to proceed?",
    generateDraftEntitlementConfirmationMessage:
      "All draft payments will be deleted once draft entitlement is calculated. Are you sure to proceed?",
    caluclationConfirmationMessage:
      "Are you sure you would like re-calculate the results again after the current calculation is completed?",
    calculateEntitlement: "Calculate Entitlement",
    calculateEntitlementLoaderText: "Calculating Entitlement",
    entitlementSuccessMessage:
      "Entitlement calculation is completed for {{distributionName}}.",
    entitlementErrorMessage: "Unable to calculate entitlement.{{errorMessage}}",
    caluclationError: "Unable to calculate. {{errorMessage}}",
    caluclationPendingMessage:
      "Calculation is currently in progress, please do not update distribution configuration until it's complete.",
    entitlementPendingMessage:
      "Entitlement Calculation is currently in progress. Please do not update step configurations until it is done.",
    calculateSettlement: "Calculate Settlement",
    calculateSettlementLoaderText: "Calculating Settlement",
    settlementSuccessMessage:
      "Settlement calculation is completed for {{distributionName}}.",
    settlementErrorMessage: "Unable to calculate settlement.{{errorMessage}}",
    settlementPendingMessage:
      "Settlement Calculation is currently in progress. Please do not update step configurations until it is done.",
    distrbutionBanner: {
      title: "Distribution Name",
      label: "Last Updated Date",
      distributionDate: "Distribution Date",
      status: "Status",
      effectiveDate: "Effective Date",
    },

    distributionFormLabels: {
      duplicateDistributionCheckBox:
        "Duplicate from the last committed distribution",
      executionLog: "Execution Log",
      distributionName: "Distribution Name",
      createdFromPreviousDistribution: "Created from Previous Distribution",
      distributionNameFrench: "Distribution Name (French)",
      status: "Status",
      distributionDate: "Distribution Date",
      description: "Description",
      descriptionFrench: "Description (French)",
      effectiveDate: "Effective Date",
      createdOn: "Created On",
      entitlementCalculation: "Last Entitlement Calculation",
      lastSettlementCalculation: "Last Settlement Calculation",
    },
    validationMessages: {
      distributionNameReq: "Please enter a distribution name",
      distributionDateReq: "Please enter a distribution date",
    },
    distributionSetup: "Distribution Setup",
    deleteDistribution: "Delete Distribution",
    warningMessage:
      "Are you sure you want to delete this distribution <strong>{{entityName}}</strong>?",
  },
  distributionStepsTab: {
    stepBannerDetails: {
      title: "Calculation Step Name",
      label1: "Distribution Name",
      label2: "Last Updated Date",
      label3: "Step Order",
    },
    stepOrderValidation:
      "Unable to reorder this step as it's being referenced by a later step.",
    previewEntitlementResult: "Preview Entitlement Result",
    exportLastRanEntitlementAmounts: "Export Last-Ran Entitlement Amounts",
    previewEntitlementAmounts: "Preview Entitlement Amounts",
    addNewStep: "New Step",
    tableTitle: `Steps`,
    tableDescription: `Each Step in a distribution is either an memo step or a payable step. Steps can reference earlier steps in the current distribution, or any step from a previous distribution.`,
    validationMessages: {
      stepNameRequired: "The Step name cannot be empty or contain only spaces.",
      payeeTypeRequired: "Payee Type is required",
      stepNameRequiredMessage: "Step Name is required",
      accontRequired: "Account is required",
      subAccountRequired: "Sub Account is required",
      calucationRequired: "Calculation Group By is required",
      memoRequired: "Memo is required",
      mainMessage:
        "Please complete all required fields to continue. , {{fieldNames}} cannot be left blank.",
    },
    stepFormView: {
      title: "Step Summary",
      description:
        "These are the step data source, filter, and calculation details. Each step must have a sub-account selected where the step's results will be summarized in all distribution reports.",
    },
    claculationGroupByOptions: {
      option1: "Select Calculation Group By",
      option2: "Creditors",
      option3: "Claims",
      option4: "Assignee/Creditor",
      option5: "Case",
    },
    payableOptions: {
      option1: "Payable",
      option2: "Memo",
    },
    columnDetails: {
      column1: "Order",

      column2: "Step Name",

      column3: "Sub Account Name",

      column4: "Payable/Memo",

      column5: "Payment Grouping",

      column6: "Payee Type",

      column7: "Updated On",

      column8: "Updated By",

      column9: "Comment",
    },
    distributionBanner: {
      title: "Calculation Step Name",
      label1: "Distribution Name",
      label2: "Last Updated Date",
    },
    stepFormLabels: {
      stepName: "Step Name",
      account: "Account",
      subAccount: "Sub Account",
      subAccountNew: "Sub Account New",
      futureReferencingLogic: "Future Referencing Logic",
      calculationGroupBy: "Calculation Group By",
      payeeType: "Payee Type",
      memo: "Payable/Memo",
      comment: "Comment",
      description: "Description",
    },
    resultSettingTab: {
      title: "Result Setting",
      description:
        "Results will be rounded based on the Rounding setting, to a multiple of the 'Issue in Multiples of'. If the result is less than the 'Minimum Issue Amount', then the result will be zero.",
      formLabels: {
        multipleIssue: "Issue in Multiples of",
        rounding: "Rounding",
        minimumIssueAmount: "Minimum Issue Amount",
      },
      validationMessage: {
        multipleIssueRequired: "Issue in multiples of is required",
        roundRequired: "Rounding is required",
        minimumIssueRequired: "Minimum Issue amount is required",
        multipleIssueInvalid: "Issue in multiples is Invalid",
        minimumIssueInvalid: "Minimum Issue amount is Invalid",
      },
      roundingOptions: {
        label: "Select Rounding",
        label1: "Round up",
        label2: "Round down",
        label3: "Round to nearest",
        label4: "No rounding",
      },
    },
    cap_Floor_AmountTab: {
      title: "Cap & Floor Amount",
      description:
        "Use the cap and floor to create a maximum or minium amount for this calculation step. The cap and floor are applied at the Calculation Group By level.",
      formLabels: {
        capAmount: "Cap Amount",
        floorAmount: "Floor Amount",
      },
      validationMessage: {
        capAmountRequired:
          "Please ensure Cap Amount is greater than Floor Amount",
        capAmountInvalid: "Cap Amount is Invalid",
        floorAmountInvalid: "Floor Amount is Invalid",
      },
    },
    limitAmountTab: {
      tableTitle: "Limit Amount",
      createLimitAmount: "New Limit Amount",
      tableDescription:
        "Use the Limit Amount to create a maximum or minimum amount for this calculation step that are dynamically calculated based on a previous step or data source. If the previous step or data source does not contain any records,  either 1) 'No Limit Applied' will not impose any limit or 2) 'Cap Limited to Zero' will apply a limit of exactly zero. The cap and floor are applied at the Calculation Group By level.",
      limitCapCheckBox: "Use Zero Limit as Cap",
      limitFloorCheckBox: "Use Zero Limit as Floor",
      applyCapFirst: "Apply Cap First",
      applyFloorFirst: "Apply Floor First",
      deleteWarningMessage:
        "Are you sure you want to delete this limit amount?",
      columnDetails: {
        column1: "Type",
        column2: "Data Source",

        column3: "Weighting Factor",

        column4: "Filter Applicable Classes",

        column5: "Manual Data Source",

        column6: "Calculation Step Name",
        column7: "Distribution",
      },
      limitFormCreate: {
        title: "Limit Amount",
      },
      limitFormEdit: {
        title: "Edit Limit Amount",
      },
      typeOptions: {
        label: "Select Type",
        label1: "Floor",
        label2: "Cap",
      },
      dataSourceOptions: {
        label1: "Select Type",
        label2: "Accepted Claims",
        label3: "Prior Step",
        label4: "Manual Data Sources",
      },
      entitlementOptions: {
        label1: "Select Type",
        label2: "Entitlement",
        label3: "Settlement",
      },
      validationMessages: {
        typeRequired: "Type is required",
        dataSourceRequired: "Data Source is required",
        entitlementRequired: "Entitlement/Settlement is required",
        manualDataSourceRequired: "Manual Data Source is required",
        distributionRequired: "Distribution is required",
        caluclationStepRequired: "Calculation Step is required",
        weighingRequired: "Weighting Factor is required",
        weighingNumericRequired: "Weighting Factor is not numeric",
        applicableRequired: "Filter Applicable Classes is required",
      },
      formLabels: {
        type: "Type",
        datasource: "Data Source",
        entitlement: "Entitlement/Settlement",
        manualDataSource: "Manual Data Source",
        distribution: "Distribution",
        calculationStep: "Calculation Step",
        weightingFactor: "Weighting factor",
        applicable: "Filter Applicable Classes",
      },
    },
    rateTierTab: {
      tableTitle: "Rate Tier {{titleExt}}",
      createRateTire: "New Rate Tier",
      tableDescription:
        "The applicable Rate Tier row is based on the first Rate Tier Row where [Tier Min]<=[weighted Amount]<=[Tier Max]. Rate Tier formula: ([weighted Amount]-[Tier Min])*[Tier Rate]+[Adjustment]",
      createTemplate: "Create from Template",
      saveTemplete: "Save as Template",
      successMessage: "Rate Tier updated successfully.",
      deleteWarningMessage: "Are you sure you want to delete this Rate Tier?",
      columnDetails: {
        column1: "Tier Max Amount",

        column2: "Tier Min Amount",

        column3: "Tier Rate",

        column4: "Adjustment",
      },
      maxAmountWarningMessage:
        "Please ensure Tier Max Amount is greater than Tier Min Amount",
      validationMessages: {
        rateRequired: "Tier Rate is required",
        adjustmentRequired: "Adjustment is required",
        mainMessage: "Please fill all the required fields",
        unlimitedMessage:
          "Please specify either the Tier Max Amount or Tier Floor Amount. Unable to save rate tier when both are unlimited.",
        sameMaxMinValueMessage:
          "Tier Max and Tier Min value cannot both be unlimited.",
        minMaxValueFormateMeessage:
          "Min and Max value must have the same sign. If Min value is unlimited, Max Value must be <= 0. If Max Value is unlimited, Min Value must be >= 0.",
        minvalueRangeMesaage: "Min must always be less than or equal to Max",
        minMaxAlreadyExistsMessage:
          "Tier with same Max and Min amount already exists. Please enter different values.",
      },
      createNewTemplate: {
        validationMessages: {
          yearRequired: "Year must be between 1900 and 2100",
        },
        title: "Create New Template",
        name: "Name",
        year: "Year",
        jurisdiction: "Jurisdiction",
      },
      formLabels: {
        createTitle: "Rate Tier",
        editTitle: "Edit Rate Tier",
        tierMaxAmount: "Tier Max Amount",
        tierMinAmount: "Tier Min Amount",
        tierFloorAmount: "Tier Min Amount",
        rate: "Tier Rate",
        adjustment: "Adjustment",
      },
    },
    classFilterTab: {
      tableTitle: "Class Filter",
      classFilterCreateTitle: "Class Filter",
      classFilterEditTitle: "Class Filter",
      createClassFilter: "New Class Filter",
      tableDescription:
        "Only one Scheme can be selected per step. If applied only those Claim Elements that are part of the selected Classes will be included in the step calculations. Each Class can have a different weighting impact of the step results.",
      deleteWarningMessage:
        "Are you sure to delete this class filter <strong>{{deleteEntityName}}</strong>?",
      classFilter: "Class Filter",
      weightFactor: "Weighting Factor",
      schemeReq: "Scheme is required",
      classReq: "Class is required",
      weightingFactorReq: "Weighting Factor is required",
      weightingFactorReqNum: "Weighting Factor is a number",
      validationMessage:
        "Please complete all required fields to continue. {{fieldNames}} cannot be left blank Or invalid",
      validationMessageWithEmpty:
        "Please complete all required fields to continue. {{fieldNames}} is invalid",
      class: "Class",
      scheme: "Scheme",
      columnDetails: {
        column1: "Class Name",
        column2: "Weighting Factor",
      },
    },
    dataSourceTab: {
      createNewDataSource: "New Data Source",
      tableTitle: "Data Sources",
      tableDescription:
        "Multiple Data Sources can be selected. Each Data Source has it's own weighting. Data sources can be a combination of 1) Accepted Claims, 2) Prior Step, or 3) Manual Data Source. If the 'Filter Appicable Classed' is unchecked, then the Class Filters are ignored for that Data Source.",
      deleteWarningMessage:
        "Are you sure to delete this data source <strong>{{deleteEntityName}}</strong>?",
      columnDetails: {
        column1: "Data Source",
        column2: "Manual DataSource",
        column3: "Distribution",
        column4: "Step",
        column5: "Weighting Factor",
        column6: "Entitlement/Settlement",
        column7: "Filter Applicable Classes",
      },
      dataSourceCreateTitle: "Data Source",
      dataSourceEditTitle: "Data Source",

      validationMessages: {
        mainMessage:
          "Please complete all required fields to continue. {{fieldNames}} cannot be left blank Or invalid",
        entitlementReq: "Entitlement/Settlement is required",
        futureReferencingLogicReq: "Future Referencing Logic is required",
      },
      dataSourceOptions: {
        label1: "Select Type",
        label2: "Accepted Claims",
        label3: "Prior Step",
        label4: "Manual Data Sources",
      },
      entitlementOptions: {
        label1: "Select Type",
        label2: "Entitlement",
        label3: "Settlement",
      },
      formLabels: {
        dataSource: "Data source",
        weightingFactor: "Weighting Factor",
        distribution: "Distribution",
        calculationStep: "Calculation Step",
        entitlement: "Entitlement/Settlement",
        manualDataSource: "Manual DataSource",
        applicableClass: "Filter applicable classes",
      },
    },
    distributionCreate: {
      title: "Step summary",
      description: "Descriptive text that describes your page or content.",
    },
  },
  manageDataSource: {
    title: "Manual Data Sources",
    deatails: "Manual Data Source Details",
    description: "Descriptive text that describes your page or content.",
    usage: "Usage",
    usageDescription: "Descriptive text that describes your page or content.",
    cancel: "Cancel",
    download: "Download",
  },
  accounts: {
    title: "Accounts",
  },
  PayeeType: {
    title: "Payee Type",
  },
  rateTierTemplate: {
    title: "Rate Tier Template",
  },
};

export default distributions;
